import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SettingsService } from '../shared/services/settings.service';
import { ProviderWebsiteLanguageModel } from '@admin/shared/models/provider-website-language-model';
import { StaticContentRawModel } from '../shared/models/static-content-raw-model';
import { StaticContentSubmitDataModel } from '../shared/models/static-content-submit-data-model';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { MessageType } from '@admin/core/models/enum/message-type';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';

import { CustomMessageService } from '@admin/core/message.service';
import { StaticContentFilterModel } from '../shared/models/static-content-filter-model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-info-pages-edit',
  templateUrl: './info-pages-edit.component.html',
  styleUrls: ['./info-pages-edit.component.less'],
  standalone: false,
})
export class InfoPagesEditComponent implements OnInit {
  public language: ProviderWebsiteLanguageModel;
  public providerWebsiteId: number;
  public providerWebsiteName: string;
  public resourceTitle: string;
  public alias: string;
  public data: StaticContentSubmitDataModel;
  public filter: StaticContentFilterModel;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private messageService: CustomMessageService,
    private translationService: TranslateService,
    private settingsService: SettingsService
  ) {
    this.data = new StaticContentSubmitDataModel();
    this.filter = new StaticContentFilterModel();
  }

  ngOnInit() {
    this.route.params.subscribe((p) => {
      this.providerWebsiteId = p['id'];
      this.providerWebsiteName = p['name'];
      this.resourceTitle = p['title'];
      this.alias = p['alias'];
      this.initializeLanguages();
    });
  }

  private initializeLanguages() {
    this.settingsService.GetPrimaryAndAltLanguages().subscribe((lang) => {
      this.language = lang;
      this.initializeContent();
    });
  }

  private initializeContent() {
    this.filter.alias = this.alias;
    this.filter.primaryLanguage = this.language.primaryLanguageCode;
    this.filter.alternativeLanguage = this.language.alternativeLanguageCode;
    this.settingsService.GetTitleAndContent(this.filter).subscribe((data) => {
      this.data = data;
    });
  }

  public onUpdate() {
    this.filter = new StaticContentFilterModel();
    this.filter.staticContentId = this.data.primaryData.staticContentId;
    this.filter.primaryLanguage = this.data.primaryData.languageCode;
    this.filter.alternativeLanguage = this.data.alternativeData.languageCode;

    this.settingsService
      .UpdateStaticContent(this.data, this.filter)
      .subscribe(() => {
        this.messageService.pushMessage(<ApplicationMessage>{
          type: MessageType.Success,
          sourceId: ApplicationMessageSource.global,
          summary: 'static content changed',
          detail: this.translationService.instant('message.SaveMessage'),
        });
        this.onCancel();
      });
  }

  public onCancel() {
    this.router.navigate(['./settings/info-pages']);
  }

  public onFocus(event: any) {
    // this solves an "Uncaught type error: cannot read property 'isInline' of null.."
    event.editor.focusManager.blur(true);
  }
}
